export const locale = {
    lang: 'ar',
    data: {
        PROJECTS_SESSION_NEW_DIALOG_CREATE_SESSION: 'إضافة ورشة',
        PROJECTS_SESSION_NEW_DIALOG_GENERAL: 'عُمومِيات',
        PROJECTS_SESSION_NEW_DIALOG_MEMBERS: 'الأعضاء'
    }
};
